import {inject, Injectable} from '@angular/core';
import {StorageService} from '../../../shared/services/storage.service';
import {RELEASE_NOTES, ReleaseNote} from './release-notes.data';

const LAST_SEEN_KEY = 'release-note-last-seen';

@Injectable({providedIn: 'root'})
export class ReleaseNotesService {
  private storage = inject(StorageService);

  getNewReleaseNotes(): ReleaseNote[] {
    if (!RELEASE_NOTES.length) {
      return [];
    }

    const lastSeenId = this.storage.get(LAST_SEEN_KEY);

    if (!lastSeenId) {
      return [RELEASE_NOTES[0]];
    }

    return RELEASE_NOTES.filter(note => note.id > lastSeenId).slice(0, 5);
  }

  markAsSeen(): void {
    if (!RELEASE_NOTES.length) {
      return;
    }

    this.storage.set(LAST_SEEN_KEY, RELEASE_NOTES[0].id);
  }
}
